import Vue from 'vue';
import OverlayPanel from 'primevue/overlaypanel';

Vue.component('OverlayPanel', OverlayPanel);
